module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dYiXP"))).then(() => module.bundle.root('d181N'));